import React from 'react';
import { Text } from '@perch-labs/shrike';
import { LoadingModule } from 'components/loading';
import { LmiStyledRowChild, LmiTableHeader } from './lmi-table-util.component';
import { TableWrapper } from './lmi-table.style';

type TableProps = {
  data?: ({
    proofDocUrls: (string | null)[];
    proofDocName: string | null;
    proofDocStatus: string | null;
    proofDocUploadedAt: string | null;
    uaLmiSourceTypeId: number | null;
    utilityAccountId: number | null;
    utilityName: string | null;
    utilityAccountNumber: string | null;
    utilityServiceAddress: string | null;
    rejectionReason: string | null;
    reasonMessage: string | null;
  } | null)[];
  default: string;
  loading: boolean;
};

export const LmiTable = (props: TableProps) => {
  const { loading, data, default: defaultCopy } = props;
  const sortedData =
    !loading && data!.length > 0
      ? [...data!].sort((a, b) => {
          if (a?.proofDocStatus === 'pending_review') return -1;
          if (b?.proofDocStatus === 'verified') return 1;
          if (b?.proofDocStatus === 'rejected') return 2;
          return 3;
        })
      : [];
  const filteredData =
    sortedData.length > 0
      ? sortedData.filter(
          val => val?.rejectionReason !== 'not_eligible_for_ira'
        )
      : [];

  if (loading)
    return <LoadingModule variant="generic" margin={{ bottom: '24px' }} />;

  return filteredData.length === 0 ? (
    <Text margin={{ bottom: '24px' }}>{defaultCopy}</Text>
  ) : (
    <TableWrapper>
      <table>
        <LmiTableHeader />
        {filteredData.map((val, key) => {
          return (
            <tr key={key}>
              <LmiStyledRowChild rowData={val} />
            </tr>
          );
        })}
      </table>
    </TableWrapper>
  );
};
